<template>
  <li :class="{ 'slo-tab': true, active }" @click.prevent="handleClick($event)">
    <button v-stack-x:xs>
      <slot v-if="typeof title === 'undefined'" />
      <span v-else v-html="title" />
    </button>
  </li>
</template>

<script>
export default {
  name: 'SloTab',
  props: {
    name: {type: String, required: true},
    component: {type: [String, Object]},
    title: {type: String}
  },
  data() {
    return {
      index: 0,
      currentIndex: 0
    };
  },
  created() {
    this.index = this.$parent.$data.index;
    this.$parent.$data.index++;

    window.addEventListener('resize', this.handleResize);

    const active = this.$parent.$data.internalValue === this.name;
    if (active) {
      this.$parent.$data.currentTabView = this.__component;
      this.$parent.$data.currentTabIndex = this.index;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    if (this.active) {
      this.$parent.$data.currentTabRect = this.$el.getBoundingClientRect();
    }
  },
  computed: {
    active() {
      return this.$parent.$data.internalValue === this.name;
    },
    __component() {
      if (this.component) return this.component;
      if (typeof this.title !== 'undefined') {
        if (typeof this.$slots.default !== 'undefined') {
          const children = this.$slots.default;
          return {
            functional: true,
            render: (h, ctx) => h('div', ctx, children)
          };
        }
      }
      return null;
    }
  },
  methods: {
    handleResize() {
      const active = this.$parent.$data.internalValue === this.name;
      if (!active) return;
      this.$parent.$data.currentTabRect = this.$el.getBoundingClientRect();
    },
    handleClick($event) {
      if (this.active) return;
      const rect = $event.target.getBoundingClientRect();

      this.$parent.onTabChange({
        name: this.name,
        component: this.__component,
        index: this.index,
        rect
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/system';

slo-tab {
  padding: 10px !important;
  color: #a8aaad;
  font: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
}

slo-tab + slo-tab {
  margin-left: 12px;
}

slo-tab[title] {
  &::before {
    content: attr(title);
    color: #a8aaad;
    font: inherit;
    text-transform: inherit;
    letter-spacing: inherit;
  }

  > * {
    display: none;
  }
}

slo-tab.active {
  color: $color-blue-400 !important;
}
</style>

<style lang="scss" scoped>
@import '../../scss/system';

.slo-tab {
  &.active {
    button {
      color: $color-blue-400 !important;
    }
  }

  button {
    padding: 10px !important;
    background: none;
    border-radius: 0;
    color: #a8aaad;
    font: inherit;
    text-transform: inherit;
    letter-spacing: inherit;
  }

  &:hover,
  &:active {
    button {
      color: $color-gray-700;
    }
  }
}
</style>
